export enum ButtonModifier {
  /**
   * colour
   */
  ClrPrimary = 'primary',
}
